/* src/app/job-signoff-land-services/pages/job-signoff-delete-job/job-signoff-delete-job.component.scss */
/*# sourceMappingURL=job-signoff-delete-job.component.css.map */
